import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { dayString, isSameDate } from "src/helpers";
import { naruhoneStyles } from "src/styles/naruhoneStyles";

const GitCalendar = () => {
  const [activeTooltip, setActiveTooltip] = useState(null);
  const [selectedDay, setSelectedDay] = useState(null);
  const [currentHover, setCurrentHover] = useState(null);
  const timeoutId = useRef(null);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 }); // Tracks tooltip position
  const svgRef = useRef(null);

  const [calendarView, setCalendarView] = useState("weekly");

  const daysAchieved = useSelector((state) => state.dashboard?.naruhone?.gitTracker);

  const year = 2025;
  const daysInMonth = [
    31,
    year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0) ? 29 : 28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31,
  ];
  const squareSize = 14;
  const padding = 15;
  const startDay = new Date(year, 0, 1).getDay(); //1 is monday
  let currentDay = new Date();
  currentDay = new Date(
    currentDay.getFullYear(),
    currentDay.getMonth(),
    currentDay.getDate()
  );

  const calendar = [];
  let dayCounter = 0;
  for (let i = 0; i < daysInMonth.length; i++) {
    for (let j = 1; j <= daysInMonth[i]; j++) {
      const week = Math.floor((dayCounter + startDay) / 7);
      const dayOfWeek = (dayCounter + startDay) % 7;

      calendar.push({
        id: dayCounter,
        x: week * squareSize,
        y: padding + dayOfWeek * squareSize,
        date: new Date(year, i, j),
      });

      dayCounter++;
    }
  }
  const colors = ["#ececec", "#c6e48b", "#7bc96f", "#196127"];
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  let listOfDates = [
    new Date(2025, 2, 2),
    new Date(2025, 1, 25),
    new Date(2025, 1, 24),
    new Date(2025, 10, 10),
    new Date(2025, 12, 20),
  ];
  const handleMouseEnter = (id, day) => {
    const svgRect = svgRef.current.getBoundingClientRect(); // Get SVG's position and size
    // const mouseX = day.x - svgRect.left; // Adjust X relative to SVG
    // const mouseY = day.y - svgRect.top;
    // Start the delay
    setCurrentHover(id);
    timeoutId.current = setTimeout(() => {
      setTooltipPosition({ x: day.x + squareSize / 2, y: day.y });
      setActiveTooltip(id);
    }, 300); // Adjust delay (in milliseconds) as needed
  };
  const handleMouseLeave = () => {
    clearTimeout(timeoutId.current);
    setCurrentHover(null);
    setActiveTooltip(null);
  };
  

  return (
    <div className={` h-full w-full p-1 pl-4 pr-2`}>
      {calendarView === "weekly" && (<>
      
        {[{name:"Gym tracker 🏋️‍♂️💪", color:"checkbox-primary", dataName:"gym"},
          {name:"Wanikani 🎌🐊🦀", color:"checkbox-secondary", dataName:"japanese"}
        ].map((h,idx) => {
          let habitDays = [];
          if(daysAchieved !== undefined){
            for (const key in daysAchieved) {
    const value = daysAchieved[key];
              if(key.toString().toLowerCase() === h.dataName){
                habitDays = value;
              }
              }
            }
          return <div key={idx} className={`flex flex-wrap items-center `}>
            <p className={`${naruhoneStyles.h2Text} text-lg whitespace-nowrap flex-[1] text-sm lg:text-lg block`}>
              {h.name}
            </p>
            <div className={`  flex flex-[2] h-full justify-center`}>
              <div className={`flex-[1] h-full w-full bg-green-500`}> </div>
              <div className={`flex-[3] flex w-full h-full gap-2`}>
              {calendar
                .filter((d) => {
                  let date7DaysAgo = new Date().setDate(
                    currentDay.getDate() - 7
                  );
                  return d.date <= currentDay && d.date >= date7DaysAgo;
                })
                .map((d, idx2) => {
                  let isHabitChecked = (habitDays?.find((hd) => {
                    let hdate = new Date(hd);
                    return isSameDate(d.date, hdate) 
                  })) ? true : false
                  
                  return (
                    <div
                      key={idx2}
                      title={`${d.date.toString()}`}
                      className="flex flex-col items-center h-full"
                    >
                      <p
                        className={`${naruhoneStyles.pText} text-xs font-bold`}
                      >
                        {idx2 === 6 ? "TODAY" :dayString(d.date).substring(0, 3).toUpperCase()}
                      </p>
                      
                      <div className="pointer-events-none">
                        <input
                          type="checkbox"
                          checked={isHabitChecked}
                          readOnly
                          className={`checkbox ${h.color}`}
                        />
                      </div>
                    </div>
                  );
                })}
                </div>
                <div className={`flex-[1] h-full w-full bg-green-500`}></div>
            </div>
          </div>
              }
        )}
        </>
      )}
    </div>
  );
};

export default GitCalendar;
